import Page from 'components/modules/public/pages/LoginWorker';
export default Page;